"use client";

import type IFetchCreative from "@/repositories/IFetchCreative";
import dynamic from "next/dynamic";

// ssr: false must live in a client component (Next.js 15 restriction).
// core-creatives uses Less.js which accesses localStorage during CSS
// compilation — unavailable / broken in Node.js SSR context.
const CreativePreview = dynamic(
  () => import("@/app/components/Preview/PreviewCreative"),
  { ssr: false },
);

const PreviewCreativeClient = ({
  id,
  creativeJSON,
  isInternalUser,
  searchParams,
}: {
  id: string;
  creativeJSON: IFetchCreative;
  isInternalUser: boolean;
  searchParams: URLSearchParams;
}) => (
  <CreativePreview
    id={id}
    creativeJSON={creativeJSON}
    isInternalUser={isInternalUser}
    searchParams={searchParams}
  />
);

export default PreviewCreativeClient;
